// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"72":"2438ae84","682":"f66f47d2","822":"b7837fd7"}[chunkId] + ".js";
};